import { render, staticRenderFns } from "./compras.vue?vue&type=template&id=0ddee4dd"
import script from "./compras.vue?vue&type=script&lang=js"
export * from "./compras.vue?vue&type=script&lang=js"
import style0 from "./compras.vue?vue&type=style&index=0&id=0ddee4dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports